// extracted by mini-css-extract-plugin
module.exports = {"News":"reviews_News__Oc5ll","Text":"reviews_Text__Isf7q","TextLeft":"reviews_TextLeft__pnx0c","TextDate":"reviews_TextDate__V7mUU"};